module.exports = __webpack_public_path__ + "assets/8db9125edfd73e061097fa40655db62d.mp3";